export default __webpack_public_path__ + "static/iBeta-fc4d746c7a8e7de0bbf5b8c41073a364.png";